import { login, getUserInfo, refreshToken, substituteLoginApi } from '@/api/user'
import { updateHomeConfig } from '@/api/settings'
import { setToken, getToken, setTokenRegTime, setUserId, getUserId, localSave, setSelTenants, getSelTenants, getLoginWay, setLoginWay } from '@/libs/util'
import { initRouter } from '@/libs/router-util' // 动态菜单渲染
// import config from '@/config'

export default {
  state: {
    userName: '',
    name: '',
    userId: getUserId(),
    avatorImgPath: '',
    token: getToken(),
    access: '',
    baseHeaders: { 'Authorization': 'OPS ' },
    hasGetInfo: false,
    superuser: false,
    permissions: [],
    menus: [],
    tenants: [],
    groups: [],
    selTenants: getSelTenants(),
    defaultTenant: 0,
    loginWay: getLoginWay(),
    user: {}
  },
  mutations: {
    setAvator (state, avatorPath) {
      state.avatorImgPath = avatorPath
    },
    setUserId (state, id) {
      state.userId = id
      setUserId(id)
    },
    setUserName (state, name) {
      state.userName = name
    },
    setName (state, name) {
      state.name = name
    },
    setAccess (state, access) {
      state.access = access
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setRegTokenTime (state, token) {
      let time = parseInt((new Date()).getTime() / 1000)
      setTokenRegTime(time)
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setBaseHeaders (state, token) {
      state.baseHeaders.Authorization = 'OPS ' + token
    },
    setSuperuser (state, superuser) {
      state.superuser = superuser
    },
    setPermissions (state, permissions) {
      state.permissions = permissions
    },
    setMenus (state, menus) {
      state.menus = menus
      initRouter(menus)
    },
    setLocale (state, locale) {
      // 清晰后台数据, 组装成前台需要的结构
      const list2Dict = (list) => {
        let dict = {}
        list.map(item => { dict[item.key] = item.value })
        return dict
      }
      localSave('langLocale', JSON.stringify(list2Dict(locale))) // 保存当前语言包数据，持久化
    },
    setTenants (state, tenant) {
      state.tenants = tenant
    },
    setGroups (state, groups) {
      state.groups = groups
    },
    setDefaultTenant (state, tenant) {
      state.defaultTenant = tenant
    },
    setSelTenants (state, tenant) {
      state.selTenants = tenant
      setSelTenants(tenant)
    },
    setLoginWay (state, way) {
      state.loginWay = way
      setLoginWay(way)
    },
    setUser (state, user) {
      state.user = user
    }
  },
  actions: {
    // 设置当前查询租户
    handleSelTenants ({ commit }, tenants) {
      commit('setSelTenants', tenants)
    },
    // 登录
    handleLogin ({ commit }, { userName, password }) {
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        login({
          userName,
          password
        }).then(res => {
          const data = res.data
          commit('setToken', data.token)
          commit('setRegTokenTime', data.token)
          commit('setBaseHeaders', data.token)
          commit('setAvator', '')
          commit('setUserName', data.user.username)
          commit('setName', data.user.name)
          commit('setUserId', data.user.id)
          commit('setAccess', [])
          commit('setHasGetInfo', true)
          commit('setSuperuser', data.user.is_superuser)
          commit('setPermissions', data.user.permissions)
          let codeMenus = data.user.menus.filter(item => !item.is_code)
          commit('setMenus', codeMenus)
          commit('setLocale', data.user.locale)
          commit('setTenants', data.user.tenant_set)
          commit('setGroups', data.user.groups)
          if (data.user.tenant_set.length) {
            let tenantList = []
            for (let i in data.user.tenant_set) {
              tenantList.push(data.user.tenant_set[i].id)
            }
            if (data.user.home_config && data.user.home_config.defaultTenant) {
              if (tenantList.indexOf(data.user.home_config.defaultTenant) > -1) {
                commit('setDefaultTenant', data.user.home_config.defaultTenant)
              } else {
                commit('setDefaultTenant', data.user.tenant_set[0].id)
              }
            } else {
              commit('setDefaultTenant', data.user.tenant_set[0].id)
            }
            commit('setSelTenants', tenantList)
          } else {
            commit('setDefaultTenant', '')
            commit('setSelTenants', [])
          }
          commit('setUser', data.user)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      // if (config.ssoEnabled) {
      // 调用后台api 发送 sso退出信号，清除sso session 其他相关系统退出
      //   let data = {
      //     token: state.token
      //   }
      //   casLogout(data).then(res => {
      //     // 清除jwt token
      //     console.log('logout111111111111')
      //     commit('setToken', '')
      //     commit('setBaseHeaders', '')
      //     commit('setAccess', [])
      //     commit('setMenus', []) // 清空菜单
      //     localSave('userMenus', '') // 清空本地保存的菜单数据
      //     commit('setTenants', [])
      //     commit('setDefaultTenant', 0)
      //     commit('setSelTenants', [])
      //     commit('setLoginWay', false)
      //     console.log(res.data.url)
      //     return res.data.url
      //   })
      // } else {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('setToken', '')
        //   commit('setBaseHeaders', '')
        //   commit('setAccess', [])
        //   resolve()
        // }).catch(err => {
        //   reject(err)
        // })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        commit('setToken', '')
        commit('setBaseHeaders', '')
        commit('setAccess', [])
        commit('setMenus', []) // 清空菜单
        localSave('userMenus', '') // 清空本地保存的菜单数据
        commit('setTenants', [])
        commit('setGroups', [])
        commit('setDefaultTenant', 0)
        commit('setSelTenants', [])
        commit('setLoginWay', false)
        resolve()
      })
      // }
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }) {
      let userId = state.userId
      return new Promise((resolve, reject) => {
        try {
          getUserInfo(userId).then(res => {
            const data = res.data
            commit('setAvator', '')
            commit('setUserName', data.username)
            commit('setName', data.name)
            commit('setUserId', data.id)
            commit('setAccess', ['super_admin', 'admin'])
            commit('setHasGetInfo', true)
            commit('setSuperuser', data.is_superuser)
            commit('setPermissions', data.permissions)
            // 拿到菜单之后 向后台请求菜单列表 动态生成侧边栏 然后在本地保存
            let codeMenus = data.menus.filter(item => !item.is_code).concat(data.menus.filter(item => item.is_code).filter(item => item.is_code.toString() === state.loginWay.toString()))
            // commit('setMenus', data.menus.filter(item => !item.is_code).concat(data.menus.filter(item => item.is_code).filter(item => item.is_code === state.loginWay)))
            commit('setMenus', codeMenus)
            commit('setLocale', data.locale)
            commit('setTenants', data.tenant_set)
            commit('setGroups', data.groups)

            if (data.tenant_set.length) {
              let tenantList = []
              for (let i in data.tenant_set) {
                tenantList.push(data.tenant_set[i].id)
              }
              if (data.home_config && data.home_config.defaultTenant) {
                if (tenantList.indexOf(data.home_config.defaultTenant) > -1) {
                  commit('setDefaultTenant', data.home_config.defaultTenant)
                } else {
                  commit('setDefaultTenant', data.tenant_set[0].id)
                }
              } else {
                commit('setDefaultTenant', data.tenant_set[0].id)
              }
              commit('setSelTenants', tenantList)
            } else {
              commit('setDefaultTenant', '')
              commit('setSelTenants', [])
            }
            data.codeMenus = codeMenus
            commit('setUser', data)
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 刷新Token
    extendToken ({ state, commit }) {
      const token = getToken()
      return new Promise((resolve, reject) => {
        try {
          refreshToken({ token: token }).then(res => {
            const data = res.data
            commit('setToken', data.token)
            commit('setRegTokenTime', data.token)
            commit('setBaseHeaders', data.token)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    },

    // 保存DefaultTenant
    saveDefaultTenant ({ commit }, defaultTenant) {
      updateHomeConfig({ data: { defaultTenant: defaultTenant } })
    },

    substituteLogin ({ commit }, { userId }) {
      return new Promise((resolve, reject) => {
        substituteLoginApi({
          userId
        }).then(res => {
          console.log(res.data)
          const data = res.data
          commit('setToken', data.token)
          commit('setRegTokenTime', data.token)
          commit('setBaseHeaders', data.token)
          commit('setAvator', '')
          commit('setUserName', data.user.username)
          commit('setName', data.user.name)
          commit('setUserId', data.user.id)
          commit('setAccess', [])
          commit('setHasGetInfo', true)
          commit('setSuperuser', data.user.is_superuser)
          commit('setPermissions', data.user.permissions)
          let codeMenus = data.user.menus.filter(item => !item.is_code).concat(data.user.menus.filter(item => item.is_code).filter(item => item.is_code.toString() === state.loginWay.toString()))
          commit('setMenus', codeMenus)
          commit('setLocale', data.user.locale)
          commit('setTenants', data.user.tenant_set)
          commit('setGroups', data.user.groups)
          if (data.user.tenant_set.length) {
            let tenantList = []
            for (let i in data.user.tenant_set) {
              tenantList.push(data.user.tenant_set[i].id)
            }
            if (data.user.home_config && data.user.home_config.defaultTenant) {
              if (tenantList.indexOf(data.user.home_config.defaultTenant) > -1) {
                commit('setDefaultTenant', data.user.home_config.defaultTenant)
              } else {
                commit('setDefaultTenant', data.user.tenant_set[0].id)
              }
            } else {
              commit('setDefaultTenant', data.user.tenant_set[0].id)
            }
            commit('setSelTenants', tenantList)
          } else {
            commit('setDefaultTenant', '')
            commit('setSelTenants', [])
          }
          commit('setUser', data.user)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
